import { useState } from "react";

export function useAnswers() {
  var { 0: answers, 1: setAnswers } = useState({});
  var { 0: comments, 1: setComments } = useState({});

  return {
    answers: {
      value: answers,
      update: (key, value) => {
        setAnswers({ ...answers, [key]: value });
      },
    },
    comments: {
      value: comments,
      update: (key, value) => {
        setComments({ ...comments, [key]: value });
      },
    },
  };
}
